import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Loading } from 'src/components/shared/Loading';
import { LoadingFailed } from 'src/components/shared/LoadingFailed';
import { DialogRoute } from 'src/components/shared/routes/DialogRoute';
import { RootState } from 'src/features';
import { actions } from 'src/features/fortune';
import { FortunePageLayout } from '../common/FortunePageLayout';
import { FortuneExchangeConfirmDialog } from './FortuneExchangeConfirmDialog';
import { FortuneExchangeContent } from './FortuneExchangeContent';
import { FortuneExchangeFailedDialog } from './FortuneExchangeFailedDialog';
import { FortuneExchangeSucceededDialog } from './FortuneExchangeSucceededDialog';

export const FortuneExchange = () => {
  const { t } = useTranslation(['fortune', 'translation']);
  const point = useSelector((state: RootState) => state.fortune.point);
  const exchangeableItem = useSelector((state: RootState) => state.fortune.exchangeableItem);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getExchangeableItems());
  }, [dispatch]);

  if (point?.state !== 'ok') {
    return <Redirect to="/players/fortune/home" />;
  }

  return (
    <>
      <FortunePageLayout
        title={t('exchange_items')}
        backLabel={t('translation:aria_button_back_to_previous')}
        background="#f4ffe0"
      >
        {(() => {
          switch (exchangeableItem?.state) {
            case 'pending':
              return <Loading />;
            case 'ok':
              const { items } = exchangeableItem.result;
              return <FortuneExchangeContent items={items} />;
            case 'error':
              return <LoadingFailed error={exchangeableItem.error} />;
            default:
              return <></>;
          }
        })()}
      </FortunePageLayout>

      <DialogRoute path="/players/fortune/exchange/detail/:id/confirm">
        <FortuneExchangeConfirmDialog />
      </DialogRoute>
      <DialogRoute path="/players/fortune/exchange/detail/:id/succeeded">
        <FortuneExchangeSucceededDialog />
      </DialogRoute>
      <DialogRoute path="/players/fortune/exchange/detail/:id/failed">
        <FortuneExchangeFailedDialog />
      </DialogRoute>
    </>
  );
};
